import React from 'react';
import { canonicalizeInternalLinks } from '../../lib/utils';

interface PostContentProps {
  htmlContent: string;
}

// Stored post bodies start with their own `<article><header><h1>Headline</h1></header>`, repeating the
// title the page already renders as its one real <h1> (readers saw the headline twice, and crawlers saw two
// <h1> tags -- flagged by Semrush once crawlers could finally see post bodies). Drop that duplicate header
// and demote any other body <h1> so the page keeps a single <h1>.
const normalizePostHtml = (html: string): string =>
  canonicalizeInternalLinks(html)
    .replace(/<header>\s*<h1[^>]*>[\s\S]*?<\/h1>\s*<\/header>/i, '')
    .replace(/<h1(\s[^>]*)?>/gi, '<h2$1>')
    .replace(/<\/h1>/gi, '</h2>');

const PostContent: React.FC<PostContentProps> = ({ htmlContent }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: normalizePostHtml(htmlContent) }}
    />
  );
};

export default PostContent;
